var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import React, { useCallback, useEffect } from 'react';
import { Row, Col } from '../../grid';
import ExplainedChoiceBlock from './ExplainedChoiceBlock';
var ExplainedChoice = function (_a) {
    var options = _a.options, value = _a.value, onChange = _a.onChange, onBlur = _a.onBlur;
    useEffect(function () {
        if (options.length && options.length !== 3) {
            console.warn("Component \"ExplainedChoice\" was designed for 3 options, but ".concat(options.length, " was passed."));
        }
    }, [options]);
    var handleSelect = useCallback(function (nextValue) {
        onChange && onChange(nextValue);
        onBlur && onBlur(nextValue);
    }, [onChange, onBlur]);
    return (React.createElement(Row, null, options.map(function (option) { return (React.createElement(Col, { xs: 12, md: 4, key: String(option.value) },
        React.createElement(ExplainedChoiceBlock, __assign({}, option, { isSelected: option.value === value, onSelect: handleSelect })))); })));
};
export default ExplainedChoice;
